import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, HERO_IMAGE } from '../data/product';
export function FinalCTA() {
  return <section className="bg-navy px-4 py-4 sm:py-6" data-id="element-48" data-mp="3ue897ji3p2sf">
      <div className="mx-auto max-w-3xl" data-id="element-49" data-mp="c7afa9dqsein">
        <p className="text-center font-head text-[12px] font-bold uppercase tracking-[0.2em] text-volt sm:text-sm" data-id="element-50" data-mp="c8byx28tq9bz">
          ONE LAST QUESTION
        </p>
        <h2 className="mt-0.5 text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-51" data-mp="m4f0o6zrk5ye">
          When a machine fails… do you immediately know where to start?
        </h2>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-52" data-mp="vurwwwgxxnkd">
          Stop jumping between possible causes.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/85 sm:text-[15px]" data-id="element-53" data-mp="qxro4dspi6pk">
          Open the system. Find the symptom. Follow the diagnostic path.
        </p>
        <p className="mt-1 text-center font-head text-base font-bold uppercase tracking-[0.14em] text-volt sm:text-lg" data-id="element-54" data-mp="zuij0mvivfik">
          Observe. Isolate. Diagnose.
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-2 block" data-id="element-55" data-mp="2h49hls4twhsy">
          <img src={HERO_IMAGE} alt="INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO complete system" loading="lazy" className="mx-auto w-full max-w-[260px]" data-id="element-56" data-mp="2r1nrta05sact" />
        </a>

        <p className="mt-1 text-center font-head text-base font-bold uppercase tracking-wide text-white sm:text-xl" data-id="element-57" data-mp="301u1slwnes78">
          🔧 INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™
        </p>
        <p className="mt-0.5 text-center text-[13px] font-semibold uppercase leading-snug text-white/85" data-id="element-58" data-mp="39syd9bn47uxb">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR INDUSTRIAL MAINTENANCE
          TECHNICIANS
        </p>
        <p className="mt-0.5 text-center font-head text-[12px] font-bold uppercase tracking-wide text-steel sm:text-sm" data-id="element-59" data-mp="3iu4wvtl29lus">
          Fault Isolation • Motors • Mechanical • Hydraulics • Pneumatics •
          Controls
        </p>

        <p className="mt-1.5 text-center font-head text-base font-bold uppercase tracking-wide text-volt sm:text-xl" data-id="element-60" data-mp="1er3c389lv6dg">
          🔥 GET THE COMPLETE SYSTEM TODAY
        </p>
        <CTAButton href={CHECKOUT_URL} external className="mx-auto mt-1 max-w-md" data-id="element-61" data-mp="1novrsdj8og1d">
          🔧 GET INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™
        </CTAButton>
        <p className="mt-1 text-center text-[12px] font-semibold text-white/85" data-id="element-62" data-mp="1xeot8lpo3erw">
          Immediate Access • Digital Delivery
        </p>
        <p className="mt-0.5 text-center text-[12px] font-semibold text-volt" data-id="element-63" data-mp="2bdezorydmqsx">
          🛡️ 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}